import React from "react";
import "./AboutUs.css";

const extraProductsServicesCopy = `We distribute OEM and extended-capacity replacement batteries for modern smartphones and tablets, including Apple iPhone, Samsung Galaxy, Google Pixel, Motorola, OnePlus, LG, Nokia, ZTE, and Huawei models. Popular inventory includes batteries for iPhone 11–15 series, Samsung Galaxy S/Note/A series, Google Pixel models, and other high-demand devices, with select high-capacity and extended-life options consistently maintained in stock.

Our Bluetooth product return rate is approximately 2.5% - well below the sector average. We carry earpieces, stereo headphones, speakers, and our signature winter beanie hats with built-in Bluetooth audio in multiple fabrics and colors.

Our overall product return rate is below 2%, significantly lower than the 7-10% industry norm at the wholesale level - achieved through rigorous supplier evaluation and intake quality control.

Our catalog includes universal phone mounts for cars and bicycles, PU leather belt-clip pouches from compact to Note-style sizes, credit-card pouches with dual belt clips, and USB-powered accessories including fans, lights, and sharpeners.`;

const AboutUs = () => {
  return (
    <div className="about-us-wrapper">
      {/* Image Section */}
      <div className="about-us-image">
        {/* Image is set as CSS background */}
      </div>

      {/* Text Section */}
      <div className="about-us-text">
        <p>
          Since 2007, WireOx has set out to be the definitive one-stop wholesale
          source for wireless accessories and consumer electronics — serving
          big-box retailers, regional distributors, independent cell phone
          shops, and online resellers under one roof.
        </p>
      </div>

      {/* Benefits Heading */}
      <div className="benefits-heading">
        <h2>Mission Statement</h2>
      </div>

      {/* Benefits Section with Content and Image */}
      <div className="benefits-section">
        {/* Benefits Content */}
        <div className="benefits-content">
          <h3 className="benefit-title">Mission Statement</h3>
          <p className="benefit-description">
            WireOx's mission is to lead the wireless accessories distribution
            industry through quality, consistency, and innovation. We develop
            and distribute our own proprietary brands — MVolt, M! Accessories,
            Fast Charger, Fast Action Cam, and Energy Sticks — alongside Apple,
            Samsung, LG, and HTC.
          </p>
        </div>

        {/* Benefits Image */}
        <div className="benefits-image">
          {/* Image will be set as CSS background */}
        </div>
      </div>

      {/* Second Benefits Section */}
      <div className="benefits-section-2">
        <div className="benefits-content-2">
          <h3 className="benefit-title-2">Vision</h3>
          <p className="benefit-description-2">
            Since 2007, WireOx has set out to be the definitive one-stop
            wholesale source for wireless accessories and consumer electronics —
            serving big-box retailers, regional distributors, independent cell
            phone shops, and online resellers under one roof.
          </p>
        </div>
        <div className="benefits-right">
          <h3 className="benefit-title-3">Products & Services</h3>
          <p className="benefit-description-3">
            Our state-of-the-art inventory management system tracks over 3,000
            active line items and millions of transactions. Our B2B portal lets
            registered resellers browse live inventory, place orders, generate
            invoices, and track shipments in real time. Regional distributors
            can set up sub-accounts with dedicated pricing controls and
            profit-sharing modules.
          </p>
          <p className="benefit-description-3 benefit-description-3--extra">
            {extraProductsServicesCopy}
          </p>
        </div>
      </div>

      {/* Cards Section */}
      <div className="cards-section">
        <div className="card card-1">
          <div className="card-content">
            <h3 className="card-title">Wireox Team</h3>
            <p className="card-subtitle">
              Wholesale-focused support & expertise
            </p>
          </div>
        </div>
        <div className="card card-2">{/* Image set as CSS background */}</div>
        <div className="card card-3">{/* Image set as CSS background */}</div>
        <div className="card card-4">{/* Image set as CSS background */} </div>
      </div>

      {/* Brand Image Section */}
      <div className="brand-image-section">
        {/* Brand image set as CSS background */}
      </div>

      {/* Charger and Other Image Section */}
      <div className="charger-section">
        <div className="charger-left">
          <div className="charger-image">
            {/* Charger image set as CSS background */}
          </div>
        </div>
        <div className="other-image-container">
          <div className="other-image">
            {/* Other image set as CSS background */}
          </div>
          <div className="other-text-section">
            <p className="other-text">Wireox designs & distributes brands</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
